export const configuration = {
  appName: "Marketplace",
  appVersion: "1.0.0",
  defaultLanguage: "en-GB",
  languages: ["en", "gr"],
  defaultTheme: "light",
  themes: ["light", "dark"],
  multiLanguage: false,
  projectLogo: {
    src: "",
    alt: "Marketplace",
  },
  projectLogoFooter: {
    src: "",
    alt: "Marketplace",
  },
  projectFavicon: {
    src: "",
    alt: "Marketplace",
  },
  projectHomepageImg: {
    src: "homepage_img.jpg",
    alt: "Marketplace",
  },
  euLogo: {
    src: "",
    alt: "",
    fundedBy: "",
  },
  copyright: "© Netcompany SEE & EUI, ",
};

/** Used by merged main features (BackOffice policy URLs, Spline hero). Override via VITE_PROJECT_NAME. */
export const SELECTED_PROJECT = import.meta.env.VITE_PROJECT_NAME ?? "r3-mydas";
